import { Websocket_Event_Names } from '@quiz-buzz/client-common'
import { Client_Event_Name } from '@quiz-buzz/common'
import { page_header_style, Standard_Page_Layout, sub_header_style } from '../Components/Standard_Page_Layout'
import { Button } from '../Components/Button'
import { host_machine_actor } from '../App/main'
import { useSelector } from '@xstate/react'

export function Host_Connection_Closed() {
	const game_code = useSelector(host_machine_actor, (state) => state.context.game_code);

	const retry_connection = () =>
		host_machine_actor.send({type: Websocket_Event_Names.connect_websocket, detail: { game_code }})
	const reset_game = () => host_machine_actor.send({type: Client_Event_Name.reset_game})

	const header_section = <>
		<header className={page_header_style}>Problem!</header>
		{game_code ? <header className={sub_header_style}>game: {game_code}</header> : <></>}
	</>

	const content_section = <>
		<div className="two_buttons">
		{game_code ? (
			<Button text="Reconnect" button_style="Primary" onClick={retry_connection} />
		) : (
			<Button text="Back to home" button_style="Secondary" onClick={reset_game} />
		)}
		</div>
	</>

	const controls_section = <>
		<div className="two_buttons">
			<Button text="Cancel" button_style="Danger" onClick={() => host_machine_actor.send({ type: Client_Event_Name.navigate_back })} />
		</div>
	</>

	return (
		<Standard_Page_Layout
			header={header_section}
			content={content_section}
			controls={controls_section} />
	)
}
